module.exports = __webpack_public_path__ + "static/img/no-image.a4eb045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-image.jpg
// module id = aNsU
// module chunks = 1